import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConnectionDetailPage } from '@/features/data/connections/connection-pages';
import { CONNECTION_TABS, type ConnectionTab } from '@/features/data/connections/connection-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/**
 * Détail d'une connexion (lot L07). L'onglet actif vit dans l'URL (`?tab=`), l'objet exploré aussi
 * (`?object=`, l'onglet Explorer seulement).
 */
export const Route = createFileRoute('/$tenant/projects/$projectId/connections/$connectionId')({
  validateSearch: (search: Record<string, unknown>): { tab: ConnectionTab; object?: string } => {
    const tab = CONNECTION_TABS.parse(search['tab']);
    const object = typeof search['object'] === 'string' ? search['object'] : '';
    return tab === 'explore' && object ? { tab, object } : { tab };
  },
  component: ConnectionRoute,
});

function ConnectionRoute() {
  const { tenant, projectId, connectionId } = Route.useParams();
  const { tab, object = '' } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="connections"
      crumbs={[
        { label: t('nav.items.connections') },
        { label: <EntityName tenantId={tenant} kind="connection" id={connectionId} scope={{ projectId }} /> },
      ]}
    >
      <ConnectionDetailPage
        tenantId={tenant}
        projectId={projectId}
        connectionId={connectionId}
        tab={tab}
        object={object}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
